import { Suspense, useMemo, useState } from "react";

import { useDataFetch } from "../../../../hooks/useDataFetch2";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion"
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { useValidadorAsientosContablesContext } from "../../../../context/validadorAsientosContablesContext";
import { useColumnsResumenEnviados } from "../utils/columnsResumenEnviados";
import { exportExcel } from "../../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { Grid2 } from "@mui/material";
import { getArchivoGdiSac } from '../services/serviceValidadorAsientosContables'
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";

const urlTabla = `siscred-api-contabilizacion/v1/peoplesoft/obtenerregistrosenviado`;

function ResumenEnviadosComponent() {

    const { formFilters } = useValidadorAsientosContablesContext();

    const params = useMemo(() => {
        const p = new URLSearchParams();
        p.set("fechaDesde", formFilters!.fechaInicio!.toISOString().split("T")[0]);
        p.set("fechaHasta", formFilters!.fechaFin!.toISOString().split("T")[0]);
        p.set("codigoAccion", formFilters!.codigoAccion == 'Todas' ? '' : formFilters!.codigoAccion);
        p.set("numeroOperacion", formFilters!.numeroOperacion ? formFilters!.numeroOperacion : '');
        return p;
    }, [formFilters]);

    const [ idsToDownload, setIdsToDownload ] = useState<number[]>([]);

    const dataTable = useDataFetch(
        urlTabla,
        params,
        true,
    );

    const onDownloadGdiSac = async () => {
        const response = await getArchivoGdiSac(idsToDownload);
        
        if (response.data != null) {
            // 1. Decodificar base64 → bytes
            const byteCharacters = atob(response.data.fileContent);
            const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);

            // 2. Crear Blob seguro
            const blob = new Blob([byteArray], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            // 3. Crear URL temporal
            const url = URL.createObjectURL(blob);

            // 4. Crear link de descarga
            const link = document.createElement("a");
            link.href = url;
            link.download = "GDI SAC";
            document.body.appendChild(link);
            link.click();

            // 5. Limpieza
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    };

    
    const { COLUMNS } = useColumnsResumenEnviados({controlTabla: dataTable, idsToDownload, setIdsToDownload});
    const columns = useMemo(() => COLUMNS, [dataTable]);

    return (
        <CustomAccordion title={'Resumen enviados'} expandedDefault>
            <Suspense>
                <Tabla
                    columns={columns}
                    control={dataTable}
                    url={urlTabla}
                    titulo={
                        <TableHeader
                            title=""
                            control={dataTable}
                            button={
                                <Grid2 container spacing={1} sx={{ justifyContent: "flex-end", textAlign: "right" }}>
                                    <MButton
                                        type="button"
                                        variant='contained'
                                        color='primary'
                                        disabled={idsToDownload.length ? false : true}
                                        onClick={onDownloadGdiSac}
                                    >
                                        Descargar XLSX
                                    </MButton>
                                </Grid2>
                            }
                            buttonExport={
                                <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                <MButton
                                    type="button"
                                    variant="outlined"
                                    onClick={() => exportExcel(dataTable.data, columns, "resumenEnviados")}
                                    startIcon={<SummarizeTwoToneIcon />}
                                >
                                    Exportar
                                </MButton>
                                </PermissionGuard>
                            }
                        />
                    }
                />
            </Suspense>
        </CustomAccordion>
    )
}

export default ResumenEnviadosComponent;